/* global window */
import PropTypes from 'prop-types';
import React from 'react';
import Auth from './Auth';
import { get } from './server';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Outlet } from 'react-router-dom';
import classNames from 'classnames';
import { urls, CATEGORY_REQUIRED_HEADERS } from 'Reducers/categories';
import { FormattedMessage as Translation } from 'react-intl';
import { ToastMessage, TopLoader } from 'panamera-react-ui';
import EnvironmentLabel from './components/EnvironmentLabel/EnvironmentLabelAsync';
import Login from './components/Login/AsyncLogin';
import ProfileCompletion from './components/ProfileCompletion/AsyncProfileCompletion';
import { setOrigin, setBrowsingMode } from 'Actions/track';
import setToastMessageState from 'Actions/setToastMessageState';
import { getCountryLocation, getLocationsById } from 'Actions/locations';
import appClass from './App.APP_TARGET.scss';
import * as objectsHelper from 'Helpers/objects';
import * as configHelper from 'Helpers/config';
import CookiesAlert from './components/CookiesAlert/CookiesAlert';
import GoogleYolo from './components/Login/components/GoogleYolo/GoogleYolo';
import ReskinOnboarding from 'Components/ReskinOnboarding/ReskinOnboarding';
import withFooterLinks from 'HOCs/withFooterLinks/withFooterLinks';
import { beforeInstallPrompt, appInstalled, getA2HCookies } from 'Components/AddToHome/AddToHome';
import { Helmet } from 'react-helmet-async';
import { getNotifications } from 'Actions/notifications';
import { withConfig } from 'HOCs/withConfig/withConfig';
import withCookies from 'HOCs/withCookies/withCookies';
import fonts from './fonts';
import { getHaTSCookie } from 'Components/HaTS/HaTS.js';
import { getPreNotificationCookie } from 'Components/PreNotification/PreNotification';
import withTrack from 'HOCs/withTrack/withTrack';
import withChat from 'HOCs/withChat/withChat';
import FingerPrintModule from 'Helpers/asyncDeviceFingerprint';
import LeadDownloadQueuer from 'Components/LeadDownload/LeadDownloadQueuer';
import DirectionProvider from 'Components/DirectionProvider/DirectionProvider';
import withErrorBoundary from 'HOCs/withErrorBoundary/withErrorBoundary';
import LanguageOnboarding from 'Components/LanguageOnboarding/LanguageOnboarding.APP_TARGET';
import LocationOnboardingAsync from 'Components/LocationOnboarding/LocationOnboardingAsync.APP_TARGET';
import { modifiedConsole } from 'Helpers/errors';
import { getSelectedLangCode, configSelector } from 'Selectors/config';
import * as locationOnboardingConstants from 'Components/LocationOnboarding/constants';
import { AD_EVENT } from 'Constants/baxter';
import { addAdvertisingTag } from 'Helpers/tracking';
import { isOlxAutosSellPage } from 'Helpers/autosPageName';
import { getLoggedUserData } from 'Actions/user';
import CookieManager from 'Helpers/cookies';
import AsyncLeadFormV2 from './components/LeadFormV2/AsyncLeadFormV2';
import withVwo from 'HOCs/withVwo/withVwo';
import { EXPERIMENT_HOME_PAGE } from 'Pages/HomeExperiment/constants';
import { routerParamToCategoryQuery } from 'Helpers/listing';

export class App extends React.Component {
    static propTypes = {
        track: PropTypes.func,
        location: PropTypes.object,
        loginModalState: PropTypes.object,
        showProfileCompletion: PropTypes.object.isRequired,
        toastMessageState: PropTypes.object,
        config: PropTypes.object,
        setToastMessageState: PropTypes.func.isRequired,
        routeChange: PropTypes.object,
        getNotifications: PropTypes.func.isRequired,
        setOriginTrack: PropTypes.func,
        setBrowsingMode: PropTypes.func,
        marketConfig: PropTypes.shape({
            get: PropTypes.func.isRequired
        }).isRequired,
        cookies: PropTypes.shape({
            get: PropTypes.func.isRequired,
            set: PropTypes.func.isRequired
        }),
        locationOnboardingStatus: PropTypes.oneOf([
            locationOnboardingConstants.DEFAULT_VAL,
            locationOnboardingConstants.ACCEPTED,
            locationOnboardingConstants.UNACCEPTED
        ]),
        selectedLangCode: PropTypes.string,
        getLoggedUserData: PropTypes.func,
        autosPageName: PropTypes.string,
        showLeadFormV2: PropTypes.bool,
        vwoClientInstance: PropTypes.shape({
            activate: PropTypes.func.isRequired,
            getVariationName: PropTypes.func.isRequired
        }).isRequired
    };

    static defaultProps = {
        setOriginTrack: () => { },
        setBrowsingMode: () => {},
        getLoggedUserData: () => {},
        config: {}
    };

    static fetchData(dispatch, renderProps, { baseUrl, headers }, options) {
        const { config } = options;
        const locationId = config?.defaultCity?.enabled ? config?.defaultCity?.id : null;
        const countryId = config?.defaultCity?.enabled ? config?.defaultCity?.countryId : null;

        const locationsApi = locationId
            ? dispatch(
                getLocationsById(locationId, true, countryId, headers)
            ) : dispatch(
                getCountryLocation({}, baseUrl, headers, config)
            );
        const promisesArray = [
            dispatch(get(
                `${baseUrl}${urls.getCategories}`,
                'CATEGORIES',
                {},
                { ...headers, ...CATEGORY_REQUIRED_HEADERS }
            )),
            locationsApi
        ];

        return Promise.all(promisesArray);
    }

    constructor(props) {
        super(props);
        if (typeof window !== 'undefined') {
            modifiedConsole(); // initialize new console
        }
        this.state = {
            showLogin: false,
            loginRedirection: '/',
            trackProps: {},
            showLoactionOnBoarding: false
        };

        this.htmlAttributes = {
            lang: props.selectedLangCode && props.selectedLangCode.split('-')[0] || props.marketConfig.get('lang')
        };
        this.isFingerPrintGenerated = false;
        this.isNotificationHubEnabled = props.marketConfig.get('notificationHub', 'enabled');
        this.isPPCMigration = props.marketConfig.get('ppcMigration');
    }

    componentDidMount() {
        if (this.isOnItem()) {
            this.props.setOriginTrack('direct');
            this.props.setBrowsingMode('direct');
        }
        beforeInstallPrompt(this.props.track);
        appInstalled();
        getA2HCookies();
        getHaTSCookie();
        getPreNotificationCookie();

        if (Auth.isLoggedIn()) {
            if (this.isNotificationHubEnabled) {
                this.props.getNotifications();
            }
            this.props.getLoggedUserData();
        }

        /*
            THE BELOW LISTNER IS TRIGGERED FROM BAXTER LIB, olxid.min.js.
            INTENT: THIS IS FOR TP ADS LIKE GOOGLE, WITH THE HELP OF WHICH WE IDENTIFY WHETHER AN AD-SLOT HAS BEEN LOADED OR NOT
            THIS SHOULD IDEALLY BE A PART OF ADVERTISEMENT COMPONENT AS ADDING A LISTENER WHICH ADD MULTIPLE LISTENER TO WINDOW BECAUSE MULTIPLE
            INSTANCES OF ADVERTISEMENT COMPONENT ARE CREATED.
            PROPSED SOLUTION IS TO MAKE PUB SUB SORT OF UTILITY TO HANDLE THIS SCENARIO
        */
        window.addEventListener('slot_rendered_event', this.handleAdsTracking);

        const language = this.props.marketConfig.get('langs')[0];
        const theme = this.props.marketConfig.get('theme');

        fonts.load(language.dir, !!theme.customFontName);

        this.generateDeviceFingerPrint();
        addAdvertisingTag(this.props.marketConfig);

        window.addEventListener('scroll', this.handleLocationOnBoarding);
        window.addEventListener('click', this.handleLocationOnBoarding);
    }

    componentDidUpdate(prevProps) {
        if (this.props.routeChange.error && !prevProps.routeChange.error) {
            this.props.setToastMessageState(
                { isOpen: true, message: <Translation id="defaultError" />, expiration: 5000 }
            );
        }
        if (!this.isFingerPrintGenerated) {
            this.generateDeviceFingerPrint();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('slot_rendered_event', this.handleAdsTracking);
    }

    handleAdsTracking = data => {
        const status = data?.detail?.isEmpty ? 'unfilled' : 'filled';

        this.props.track(AD_EVENT, {
            status,
            variant: this.props.vwoClientInstance.getVariationName(EXPERIMENT_HOME_PAGE.HOME_PAGE)
        });
    }

    handleLocationOnBoarding = () => {
        if (this.state.showLoactionOnBoarding) {
            window.removeEventListener('scroll', this.handleLocationOnBoarding);
            window.removeEventListener('click', this.handleLocationOnBoarding);
        }
        else {
            this.setState({
                showLoactionOnBoarding: true
            });
        }
    }

    clearMessage = () => {
        this.props.setToastMessageState({ isOpen: false });
    };

    track = (event, props) => {
        this.props.track(event, props);
    };

    isOnItem = () => {
        return this.props.location.pathname.split('/')[1] === 'item';
    };

    renderCookiesAlert = () => {
        const countryConfig = configHelper.getCountryConfig(this.props.config);
        const cokal = this.props.cookies.get('cokal');

        if (!objectsHelper.isEmpty(countryConfig) && countryConfig.privacy_links && countryConfig.privacy_links.cookies_url && !cokal) {
            return <CookiesAlert />;
        }

        return undefined;
    };

    generateDeviceFingerPrint = () => {
        if (this.props.marketConfig.get('fingerPrint').enabled) {
            if (typeof window !== 'undefined') {
                this.isFingerPrintGenerated = true;
                FingerPrintModule.importFingerPrintWrapper().then(({ getDeviceFingerPrint }) => {
                    getDeviceFingerPrint();
                });
            }
        }
    };

    render() {
        const isOneTrustBannerShown = !CookieManager.readCookie('OptanonAlertBoxClosed');

        return (
            <div id="container" className={ appClass.container }>
                <DirectionProvider config={ this.props.marketConfig }>
                    <Helmet htmlAttributes={ this.htmlAttributes } />
                    <EnvironmentLabel />
                    <ReskinOnboarding />

                    {this.renderCookiesAlert()}

                    <Outlet />

                    { (this.props.toastMessageState && this.props.toastMessageState.isOpen)
                    && <ToastMessage
                        isOpen={ this.props.toastMessageState.isOpen }
                        expiration={ this.props.toastMessageState.expiration }
                        onExpired={ this.clearMessage }
                        className={ classNames(
                            { [appClass.showWithOneTrustBanner]: isOneTrustBannerShown },
                            { [appClass.showInErrorState]: this.props.toastMessageState.isErrorMessage }
                        ) }
                    >
                        { this.props.toastMessageState.message }
                    </ToastMessage>
                    }

                    <LeadDownloadQueuer />
                    {(this.state.showLoactionOnBoarding && this.props.locationOnboardingStatus === locationOnboardingConstants.UNACCEPTED) && !isOlxAutosSellPage(this.props.autosPageName)
                        && <LocationOnboardingAsync />
                    }

                    {this.props.routeChange && this.props.routeChange.loading && <TopLoader />}

                    {(this.props.loginModalState && this.props.loginModalState.state)
                        && <Login location={ this.props.location } />}

                    {this.props.showProfileCompletion.show
                        && <ProfileCompletion />}

                    { this.props.showLeadFormV2 && <AsyncLeadFormV2 /> }

                    {!Auth.isLoggedIn() && !isOlxAutosSellPage(this.props.autosPageName)
                        && <GoogleYolo />
                    }

                    { !this.isPPCMigration && <LanguageOnboarding /> }

                </DirectionProvider>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        loginModalState: state.loginModalState,
        showProfileCompletion: state.toggleProfileCompletion,
        toastMessageState: state.toastMessageState,
        config: configSelector(state),
        routeChange: state.routeChange,
        locationOnboardingStatus: state.locationOnboardingStatus,
        selectedLangCode: getSelectedLangCode(state),
        autosPageName: state.track.autosPageName,
        showLeadFormV2: state.leadFormV2?.show
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setOriginTrack: origin => dispatch(setOrigin(origin)),
        setBrowsingMode: mode => dispatch(setBrowsingMode(mode)),
        setToastMessageState: state => dispatch(setToastMessageState(state)),
        getNotifications: () => dispatch(getNotifications()),
        getLoggedUserData: () => dispatch(getLoggedUserData())
    };
};

export default compose(
    withTrack,
    withFooterLinks(routerParamToCategoryQuery),
    withChat,
    withConfig('marketConfig'),
    withCookies,
    withVwo,
    withErrorBoundary(),
    connect(mapStateToProps, mapDispatchToProps)
)(App);
